import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import GlobalStyles from "./styles/GlobalStyles";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./components/UserContext";
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme/theme';
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <UserProvider>
        <GlobalStyles />
        <App />
      </UserProvider>
    </BrowserRouter>
  </ThemeProvider>
);
